
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 200 200"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#FFF","d":"M100.003-.004c55.23 0 100 44.77 100 100s-44.77 100-100 100-100-44.77-100-100 44.77-100 100-100z"}}),_c('g',{attrs:{"fill":"#FFBE1B"}},[_c('path',{attrs:{"d":"M51.728 112.98h18.79v30.94h-18.79zM77.648 73.2h18.79v70.73h-18.79zM103.568 89.22h18.79v54.7h-18.79zM129.478 56.07h18.79v87.86h-18.79z"}})])])
          )
        }
      }
    